<div class="container">
  <div class="products__title">Rental {{ selectedMemberRegion }}</div>

  <div class="products__nav">
    <div class="search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="text" (keyup.enter)="handleSearch($event)" />
    </div>
  </div>
  <div class="products">
    @if(loading){
    <div class="card-skeleton" *ngFor="let item of [1, 1, 1, 1, 1]">
      <div class="image-placeholder"></div>
      <div class="content-placeholder">
        <div class="title-placeholder"></div>
        <div class="desc-placeholder"></div>
      </div>
    </div>
    } @else { @for(list of allProductByRegion | filterBy : 'type' : 'rental';track list){
    <common-product-card-view (view)="viewProductDetails($event)" [list]="list"
      [isCommunityProduct]="true"></common-product-card-view>
    } @empty {
    <div class="no-product">
      <div class="no-product__title">You don't have rental in your region</div>
      <button class="my-button-3" (click)="openShopPopup('rental')">Add Rental</button>
    </div>
    } }
  </div>
</div>
<app-marketplace #marketplace [share]="true"></app-marketplace>